import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { userAtom } from '@/state/atom/userAtom';
import { closeTabId, multiPanelAtom, panelInitDataAtom } from '@/state/atom/panelAtom';
import { triggerReloadTab, closePanelTabSelector, setPanelSelector } from '@/state/selector/panelSelector';

import { I18n } from 'aws-amplify';
import { isEqual } from 'lodash';
import { useSnackbar } from 'notistack';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';

import './OrganizationProfile.css';
import { FormProvider, useForm } from 'react-hook-form';
import { Button, MenuItem, TextField, Chip, Tooltip } from '@material-ui/core';
import { yupResolver } from '@hookform/resolvers';
import UpdateCorporationSchema from '@/schema/UpdateCorporationSchema';

import CropImage from '@/component/common/form/crop-image/index';
import FormInput from '@/component/common/form/input';
import PhoneInput from 'react-phone-input-2';
import ErrorHelper from '@/component/common/ErrorHelper';
import LoadingPanel from '@/component/common/LoadingPanel';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';

import { 
    getInitCorporationAndListUser, 
    handleSubmitEditCorporation, 
    onLogoFileChange, 
    handleCancelTab,
    handleCloseTab
} from '@/component/system/handler/OrganizationProfileHandler';
import { updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import OverFlowTooltipWithCustomCss from '../common/OverFlowTooltipWithCustomCss';
import { handleOnBlurSystemPromptSetting, validateTextField } from '../productManagement/handler/VersionListHandler';
import { getProductByIdAPI } from '@/service/productManagementService';
import IPRestrictionSetting from '@/component/system/components/IPRestrictionSetting';
import {
    onChangeUsingIpAddressRestrict,
    onChangeIpAddressRange,
    changeIpAddressRange
} from '@/component/project/handler/ProjectProfileManagementHandler';
import { openPromptTicketPanel } from '@/component/chatAI/handler/ChatAIHandler';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import MessageCode from '@/common/constant/MessageCode';

import PropTypes from 'prop-types';
OrganizationProfile.propTypes = {
    API: PropTypes.any,
    panelId: PropTypes.any,
    tabId: PropTypes.any
    
};
export default function OrganizationProfile(props) {
    const [initData, setInitData] = useState({});
    const [isAdminGuest, setIsAdminGuest] = useState(false);
    const [adminName, setAdminName] = useState('');
    const [adminMail, setAdminMail] = useState('');
    const [adminList, setAdminList] = useState([]);
    const [subDomain, setSubDomain] = useState('');
    const [usingChatAI, setUsingChatAI] = useState(false);
    const [lincenseKeyPermission, setLincenseKeyPermission] = useState(false);
    const [lincenseKey, setLincenseKey] = useState({
        value: '',
        error: ''
    });
    const [licenseKeyDefault, setLicenseKeyDefault] = useState('');

    const [usingAIAuto, setUsingAIAuto] = useState(false);
    const [systemPrompt, setSystemPrompt] = useState({
        value: '',
        error: '',
        linkPrompt: '',
        isPromptValid: true
    });
    const [systemPromptDefault, setSystemPromptDefault] = useState({
        value: '',
        error: '',
        linkPrompt: '',
        isPromptValid: true
    });

    const [isChangeSystemPrompt, setIsChangeSystemPrompt] = useState(false);

    const [interatorSystemPrompt, setInteratorSystemPrompt] = useState({
        value: '',
        error: '',
        linkPrompt: ''
    });
    const [interatorSystemPromptDefault, setInteratorSystemPromptDefault] = useState({
        value: '',
        error: '',
        linkPrompt: ''
    });
    const [isChangeInteratorSystemPrompt, setIsChangeInteratorSystemPrompt] = useState(false);

    const [imagePreview, setImagePreview] = useState('');
    const [logoFileName, setLogoFileName] = useState('');
    const [oldLogoFileName, setOldLogoFileName] = useState('');
    const [inputImage, setInputImage] = useState('');
    const [errorImage, setErrorImage] = useState('');
    const [croppedImage, setCroppedImage] = useState(null);
    const [corporationPhone, setCorporationPhone] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const [isShowPopUpCancel, setIsShowPopUpCancel] = useState(false);
    const [isShowPopUpCloseTab, setIsShowPopUpCloseTab] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);

    const [openCrop, setOpenCrop] = useState(false);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const reloadPanelChatbotSetting = useSetRecoilState(triggerReloadTab);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [enableOnChangeVectorData, setEnableOnChangeVectorData] = useState(true)
    const [usingIpAddressRestrict, setUsingIpAddressRestrict] = useState(false);
    const [ipAddressRange, setIpAddressRange] = useState();
    const [ipRestrictionError, setIPRestrictionError] = useState({})

    const { enqueueSnackbar } = useSnackbar();
    const cropShape = '';
    const aspect = 3 / 1;

    // common corporationDetail state
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);
    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    const [chatGPTModel, setChatGPTModel] = useState('');
    const [chatGPTModelList, setChatGPTModelList] = useState([]);
    const [knn, setKnn] = useState({
        value: '',
        error: ''
    });
    const [minScore, setMinScore] = useState({
        value: '',
        error: ''
    });

    const [chatGPTModelDefault, setChatGPTModelDefault] = useState('');
    const [knnDefault, setKnnDefault] = useState({
        value: '',
        error: ''
    });
    const [minScoreDefault, setMinScoreDefault] = useState({
        value: '',
        error: ''
    });

    const [isShowMsgSettingAI, setIsShowMsgSettingAI] = useState(false);

    const methods = useForm({
        mode: 'onBlur',
        resolver: yupResolver(UpdateCorporationSchema)
    });
    let addNewPanel = useSetRecoilState(setPanelSelector);
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [inputSystemPrompt, setInputSystemPrompt] = useState('');
    const [inputInteratorSystemPrompt, setInputInteratorSystemPrompt] = useState('');

    const { handleSubmit, errors, formState, getValues, setValue, reset, setError, register, clearErrors, unregister} = methods;

    const getInitCorpArgs = {
        API: props?.API,
        corporationId: corporationDetail.id,
        corporationDetailAtom: corporationDetail,
        panelId: props.panelId,
        tabId: props.tabId,
        setIsLoading,
        closePanelTab,
        setInitData,
        setIsAdminGuest,
        setAdminList,
        setAdminName,
        setAdminMail,
        setCorporationPhone,
        setSubDomain,
        setUsingChatAI,
        setImagePreview,
        setLogoFileName,
        setOldLogoFileName,
        register,
        setValue,
        setLincenseKeyPermission,
        setLincenseKey,
        setLicenseKeyDefault,
        setUsingAIAuto,
        setSystemPrompt,
        setSystemPromptDefault,
        setChatGPTModel,
        setChatGPTModelList,
        setKnn,
        setMinScore,
        setChatGPTModelDefault,
        setKnnDefault,
        setMinScoreDefault,
        setInputSystemPrompt,
        setInteratorSystemPrompt,
        setInteratorSystemPromptDefault,
        setInputInteratorSystemPrompt
    }

    useEffect(() => {
        if (!Utils.isEmptyObject(corporationDetail)) {
            getInitCorporationAndListUser(getInitCorpArgs)
                .then(response => {
                    if(response) setIsLoading(false);
                })
                .catch(error => {
                    setIsLoading(false);
                    console.log('get initCorp error >>>', error);
                });
        }
    }, []);

    useEffect(() => {
        if (!Utils.isEmptyObject(corporationDetail)) {
            let limitValueOfCorporation = corporationDetail?.limitValue;

            if (
                limitValueOfCorporation?.usingChatAI == 1 &&
                limitValueOfCorporation?.vectorTicketDataStatus !== Constant.VECTOR_DATA_STATUS.DONE
            ) {
                setEnableOnChangeVectorData(false);
            } else {
                setEnableOnChangeVectorData(true);
            }

            const corporationSetting = Utils.convertJSONDataToObject(
                corporationDetail?.corporationSetting
            );
            if(!Utils.isEmptyObject(corporationSetting)){
                setUsingIpAddressRestrict(corporationSetting?.usingIpAddressRestrict);
                setIpAddressRange(corporationSetting?.ipAddressRange);
            }
        }
    }, [corporationDetail]);

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (formState.isDirty || croppedImage || isEdited) {
                setIsShowPopUpCloseTab(true);
            } else {
                let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                closePanelTab({
                    event: null,
                    panelType: currentPanelInfo.type,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    useEffect(() => {
        updatePanelInitData(
            props.panelId,
            props.tabId,
            panelInitData,
            setPanelInitData,
            'isEditedData',
            isEdited
        );
    }, [isEdited]);

    useEffect(() => {
        /**
         * restore corporation ip address range. when usingIpAddressRestrict = off
         */
        const corporationSetting = Utils.convertJSONDataToObject(
            corporationDetail?.corporationSetting
        );
        if (
            !Utils.isEmptyObject(corporationSetting) &&
            corporationSetting?.ipAddressRange &&
            !usingIpAddressRestrict
        ) {
            setIpAddressRange(corporationSetting?.ipAddressRange);
        }
    }, [usingIpAddressRestrict]);

    const onChangePhoneNumber = (phoneValue, country) => {
        setCorporationPhone(phoneValue);
        setIsEdited(true);
        if (phoneValue === country.dialCode) {
            setValue('telNumberCorporation', '');
        } else {
            clearErrors('telNumberCorporation');
            setValue('telNumberCorporation', phoneValue);
        }
    };

    const onBlurPhoneInput = (e, country) => {
        let phoneValue = e.target.value;
        phoneValue = phoneValue.substring(1);

        if (phoneValue === country.dialCode) {
            setValue('telNumberCorporation', '');
            if (!isAdminGuest) {
                setError(
                    'telNumberCorporation',
                    { type: 'manual', message: I18n.get('COMMSG014') },
                    { shouldFocus: false }
                );
            }
        } else {
            setValue('telNumberCorporation', phoneValue);
            clearErrors('telNumberCorporation');
        }
    };

    const isDisableSubmitBtn  = () => {
        let isCorporationName = getValues('corporationName') ? true : false;
        let isSelectedAdmin = getValues('selectedAdmin') ? true : false;
        let isMailAdmin = getValues('mailAdmin') ? true : false;
        let isTelNumberCorporation = getValues('telNumberCorporation') ? true : false;
        let isLincenseKeyError = !Utils.isEmptyString(lincenseKey.error);
        let isSystemPromptError = !Utils.isEmptyString(systemPrompt.error);
        let isInteratorSystemPromptError = !Utils.isEmptyString(interatorSystemPrompt.error);
        let isChatGPTModelError = !Utils.isEmptyString(chatGPTModel.error);
        let isKnnValueError = !Utils.isEmptyString(knn.error);
        let isMinScoreError = !Utils.isEmptyString(minScore.error);
        let ipAddressValidation = true
        if (
            usingIpAddressRestrict &&
            !Utils.isEmptyObject(ipRestrictionError) &&
            ipRestrictionError
        )
            ipAddressValidation = false;

        if (
            isEdited &&
            isCorporationName &&
            isSelectedAdmin &&
            isMailAdmin &&
            Utils.isEmptyObject(errors) &&
            Utils.isEmptyString(errorImage) &&
            !isLincenseKeyError &&
            !isSystemPromptError &&
            !isInteratorSystemPromptError &&
            !isChatGPTModelError &&
            !isKnnValueError &&
            !isMinScoreError &&
            ipAddressValidation

        ) {
            if (isAdminGuest) {
                return false;
            } else if (!isAdminGuest && isTelNumberCorporation) {
                return false;
            }
        }

        return true;
    }

    const onSubmitEditCorporation = formData => {
        let isSystemPromptError = !Utils.isEmptyString(systemPrompt.error);
        let isInteratorSystemPromptError = !Utils.isEmptyString(interatorSystemPrompt.error);
        let isChatGPTModelError = !Utils.isEmptyString(chatGPTModel.error);
        let isKnnValueError = !Utils.isEmptyString(knn.error);
        let isMinScoreError = !Utils.isEmptyString(minScore.error);
        // Check error all fields
        if (
            !Utils.isEmptyObject(errors) ||
            !Utils.isEmptyString(errorImage) ||
            isSystemPromptError ||
            isInteratorSystemPromptError ||
            isChatGPTModelError ||
            isKnnValueError ||
            isMinScoreError ||
            !Utils.isEmptyObject(ipRestrictionError)
        ) {
            if (isShowPopUpCloseTab) setIsShowPopUpCloseTab(false);
            if (isShowPopUpCancel) setIsShowPopUpCancel(false);
            return;
        }

        //Submit data
        if (isShowPopUpCancel) setIsShowPopUpCancel(false);

        setIsLoading(true);

        const stateObj = {
            croppedImage,
            logoFileName
        };

        //set value ip retriction to formData start
        formData.usingIpAddressRestrict = usingIpAddressRestrict
        formData.ipAddressRange = ipAddressRange
        //set value ip retriction to formData 
//p1
        handleSubmitEditCorporation( 
            props?.API, 
            stateObj, 
            formData, 
            corporationDetail, 
            userDetail?.id, 
            setLincenseKey,
            setLicenseKeyDefault,
            lincenseKey, 
            usingAIAuto, 
            systemPrompt,
            chatGPTModel,
            knn,
            minScore,
            setSystemPromptDefault,
            setChatGPTModelDefault,
            setKnnDefault,
            setMinScoreDefault,
            setSystemPrompt,
            setInputSystemPrompt,
            interatorSystemPrompt,
            setInteratorSystemPrompt,
            setInteratorSystemPromptDefault,
            setInputInteratorSystemPrompt
        )
            .then(result => {
                if ( result.isEditedSuccess ) {
                    setCorporationDetail(result.corporationDetail);

                    if (result.corporationDetail?.corporationLogo) {
                        setImagePreview(result.corporationDetail?.corporationLogo);
                    }
                    if (!isEqual(result.corporationDetail, corporationDetail)) {
                        enqueueSnackbar(I18n.get('COMMSG047'), {
                            variant: 'success',
                            autoHideDuration: 3000
                        });
                        if (isShowPopUpCloseTab) {
                            setIsShowPopUpCloseTab(false)
                            handleCloseTab(
                                props.panelId,
                                props.tabId,
                                panelList,
                                closePanelTab,
                                setIsShowPopUpCloseTab
                            )
                        }
                        if(result.corporationDetail?.limitValue?.usingChatAI != corporationDetail?.limitValue?.usingChatAI && corporationDetail?.limitValue?.usingChatAI == Constant.STATUS_SERVICE_PERMISSION.ON){
                            reloadPanelChatbotSetting({
                                panelType: Constant.PANEL_TYPE.PROJECT_MANAGEMENT,
                                id: Constant.PANEL_TYPE.SYSTEM_PROJECT_SETTING_CHATBOT
                            })
                        }
                    }
                } else {
                        /**
                        * handle error for ip restriction func start
                        */
                        const errorCode = result?.error?.replace('ApiError==', '');
                        let errorIpRestrictionObject = {};
                        switch (errorCode) {
                            case MessageCode.MSG_UPDATE_IP_ADDRESS_WRONG_FORMAT:
                                errorIpRestrictionObject['ipAddressRange'] = I18n.get(
                                    'IP_ADDRESS_FORMAT_WRONG'
                                );
                                break;
                            case MessageCode.MSG_UPDATE_IP_ADDRESS_MAX_EXCCED:
                                errorIpRestrictionObject['ipAddressRange'] = I18n.get(
                                    'IP_ADDRESS_MAX_EXCCED'
                                ).replace('{{maxIpAddress}}', '150');
                                break;
                            case MessageCode.MSG_UPDATE_IP_ADDRESS_EMPTY:
                                errorIpRestrictionObject['ipAddressRange'] = I18n.get(
                                    'MSG-CM-REQUIRED-INPUT'
                                );
                                break;
                            case MessageCode.MSG_UPDATE_IP_ADDRESS_WRONG_FORMAT_DUPLICATE:
                                errorIpRestrictionObject['ipAddressRange'] = I18n.get(
                                    'IP_ADDRESS_DUPLICATE'
                                );
                                break;
                            default:
                        }
                            if (!Utils.isEmptyObject(errorIpRestrictionObject))
                                setIPRestrictionError(errorIpRestrictionObject);
                            /**
                            * handle error for ip restriction func end
                            */
                           if (result.error === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
                               setIsOpenModalReloadPage(true);
                           }
                       }
            })
            .finally(() => {
                setCroppedImage(null);
                // reset(formData);
                setIsEdited(false);
                setIsLoading(false);
                if (isShowPopUpCloseTab) setIsShowPopUpCloseTab(false);
                if (isShowPopUpCancel) setIsShowPopUpCancel(false);
            });
    };

    const handleChangeInputLincenseKey = (e) => {
        let lincenseKeyValue = e.target.value.trim();
        setIsEdited(true);
        setLincenseKey(prev => ({
            ...prev,
            value: lincenseKeyValue,
            error: ''
        }))
        setValue('lincenseKeyValue', lincenseKeyValue);
    };

    const handleDisableSystemPromptInput = () => {
        return !usingChatAI || !usingAIAuto;
    }

    const renderFieldSystemPrompt = (
        systemPromptData,
        setSystemPromptData,
        setIsChangeSystemPromptData,
        inputSystemPromptData,
        setInputSystemPromptData
    ) => {
        return (
            <div className="prompt-basic-chip-ai-auto org-profile-system-prompt-input">
                {!systemPromptData?.value ||
                (systemPromptData?.value && systemPromptData?.error) ? (
                    <TextField
                        className="form-control-input form-control-wrapInput form-control-hg32 chip-org-profile"
                        variant="outlined"
                        spellCheck={false}
                        autoComplete="seriously-please-don't-autocomplete"
                        type="text"
                        onBlur={async e =>
                            await handleOnBlurSystemPromptSetting(
                                e,
                                props?.API,
                                setIsLoading,
                                systemPromptData,
                                setSystemPromptData,
                                setIsEdited,
                                setIsChangeSystemPromptData
                            )
                        }
                        helperText={I18n.get(systemPromptData.error)}
                        error={!Utils.isEmptyString(systemPromptData.error)}
                        disabled={handleDisableSystemPromptInput()}
                        value={inputSystemPromptData}
                        onChange={e => {
                            setInputSystemPromptData(e.target.value);
                        }}
                    />
                ) : (
                    <Chip
                        label={
                            <OverFlowTooltipWithCustomCss
                                value={systemPromptData?.value}
                                placement={'top'}
                            />
                        }
                        onClick={async () => {
                            if (Utils.isEmptyString(systemPromptData?.value)) return;
                            const idTicket = await Utils.getTicketIdByShareLink(systemPromptData?.linkPrompt);
                            openPromptTicketPanel(
                                setIsLoading,
                                userDetail,
                                idTicket,
                                projectInuseDetail,
                                setIsOpenModalReloadPage,
                                addNewPanel,
                                setIsOpenAccessDeniedPopup
                            );
                        }}
                        onDelete={() => {
                            if (handleDisableSystemPromptInput()) return true;
                            setSystemPromptData(prev => ({
                                ...prev,
                                error: '',
                                value: '',
                                linkPrompt: ''
                            }));
                            setIsEdited(true);
                            setIsChangeSystemPromptData(true);
                            setInputSystemPromptData('');
                        }}
                        disableRipple={handleDisableSystemPromptInput()}
                        deleteIcon={
                            <img
                                className={`basic-chip-delete-icon ${
                                    handleDisableSystemPromptInput()
                                        ? 'basic-chip-delete-icon-disable'
                                        : ''
                                }`}
                                src="/assets/image/delete-icon-rounded.svg"
                                alt="delete"
                            />
                        }
                        className={`basic-chip chip-ai-auto ${
                            handleDisableSystemPromptInput() ? 'basic-chip-disable' : ''
                        }`}
                        // disabled={handleDisableSystemPromptInput()}
                    />
                )}
                <ConfirmDialog
                    isOpen={isOpenAccessDeniedPopup}
                    msgConfirm={I18n.get('KNOWDEMSG005')}
                    okCallBack={() => window.location.reload()}
                />
            </div>
        );
    };
    const isDisableChatGPTInput = () => {
        return Utils.isEmptyString(lincenseKey.value);
    }

    const handlerResetAISetting = async () => {
        setIsShowMsgSettingAI(false);
        setIsLoading(true);
        let versionData = await getProductByIdAPI(props?.API, corporationDetail.versionId);
        let moduleSetting = Utils.convertJSONDataToObject(versionData?.moduleSetting);

        setChatGPTModel(moduleSetting.chatGPTModel || Constant.SETTING_AI_DEFAULT.CHATGPT_MODEL_ID);
        setKnn(pre => ({...pre, value: moduleSetting.knnValue || Constant.SETTING_AI_DEFAULT.KNN_VALUE, error: ''}));
        setMinScore(pre => ({...pre, value: moduleSetting.minScore || Constant.SETTING_AI_DEFAULT.MIN_SCORE, error: ''}));
        setIsEdited(true);
        setIsLoading(false)
    }

    const handleChangeInputKnn = (e) => {
        let knnValueInput = e.target.value;
        setIsEdited(true);
        setKnn(pre => ({...pre, value: knnValueInput, error: ''}));
    };

    // const handleKeyDownInputKnn = (event) => {
    //     if (['-', '.', 'e'].includes(event.key)) {
    //         event.preventDefault();
    //     }
    // };

    const handleOnBlurInputKnn = (e) => {
        let blurValue = e.target.value

        let rules = [
            {name: 'maxValue', value: 10000},
            {name: 'minValue', value: 1},  
            {name: 'isRequire'},
            {name: 'isNumber'},
        ]
        let fieldKey = 'knn'
        const checkErrorValueInput = validateTextField(rules, blurValue, fieldKey);
        setKnn(pre => ({...pre, value: blurValue.trim(), error: checkErrorValueInput}));
    }


    const handleChangeInputMinScore = (e) => {
        let minScoreInput = e.target.value;
        if (minScoreInput.includes(".")) {
            const [integerPart, decimalPart] = minScoreInput.split(".");

            if (decimalPart && decimalPart.length > 2) {
                return;
            }
        }

        setIsEdited(true);
        setMinScore((pre) => ({ ...pre, value: minScoreInput, error: "" }));
    };

    // const handleKeyDownInputMinScore = (event) => {
    //     if (['-', 'e'].includes(event.key)) {
    //         event.preventDefault();
    //     }
    //     const inputValue = event.target.value;

    //     if (inputValue.includes(".")) {
    //         const [integerPart, decimalPart] = inputValue.split(".");
            
    //         if (decimalPart && decimalPart.length >= 2 && !isNaN(event.key)) {
    //             event.preventDefault();
    //         }
    //     }
    // };

    const handleOnBlurInputMinScore = (e) => {
        let blurValue = e.target.value

        let rules = [
            {name: 'maxValue', value: 1},
            {name: 'minValue', value: 0},
            {name: 'isRequire'},
            {name: 'isDecimal'},
        ]
        let fieldKey = 'minScore'
        const checkErrorValueInput = validateTextField(rules, blurValue, fieldKey);
        setMinScore(pre => ({...pre, value: blurValue.trim(), error: checkErrorValueInput}));
    }

    return (
        <div className="org-profile-wrap">
            <LoadingPanel isLoading={isLoading} />
            {!Utils.isEmptyObject(initData) ? (
                <>
                    <FormProvider {...methods}>
                        <div className="org-profile-wrap-header">
                            <div className="org-profile-btn">
                                <Button
                                    className="btn-light btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    disabled={!isEdited}
                                    onClick={() => handleCancelTab( isEdited, setIsShowPopUpCancel, errors, errorImage )}
                                >
                                    {I18n.get('COMBTN001')}
                                </Button>
                            </div>
                            <div className="org-profile-btn">
                                <Button
                                    className="btn-submit btn-primary btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    disabled={isDisableSubmitBtn()}
                                    onClick={handleSubmit(onSubmitEditCorporation)}
                                >
                                    {I18n.get('COMBTN011')}
                                </Button>
                            </div>
                        </div>

                        <div className="org-profile-wrap-body">
                            <div
                                className="org-profile-wrap-title"
                                data-cy="org-profile-header-title"
                            >
                                {I18n.get('ORG-INFOR-LABEL-TITLE-ORG-INFOR')}
                            </div>

                            {/* LOGO IMAGE */}
                            <div className="title-logo">{I18n.get('ORG-INFOR-LABEL-ORG-LOGO')}</div>
                            <div className="logo-wrap">
                                <div className="logo">
                                    <img
                                        src={imagePreview}
                                        alt=""
                                        onError={e => (e.target.src = '/assets/image/logo.svg')}
                                    />
                                </div>
                                <div className="logo-name">
                                    <div className="logo-filename">{logoFileName}</div>
                                    <input
                                        onChange={e =>
                                            onLogoFileChange(
                                                e,
                                                setLogoFileName,
                                                setInputImage,
                                                setOpenCrop
                                            )
                                        }
                                        accept="image/*"
                                        className="updateFile"
                                        id="contained-button-file-organization"
                                        multiple
                                        type="file"
                                    />
                                    <label htmlFor="contained-button-file-organization">
                                        <div className="upload-logo">
                                            {I18n.get('ORG-INFOR-LABEL-SELECT-FILE')}
                                        </div>
                                    </label>
                                    {errorImage && (
                                        <div className="imageError">{I18n.get('USER01MSG007')}</div>
                                    )}
                                </div>
                            </div>

                            {/* ORG-NAME */}
                            <div className="org-profile-field">
                                <div className="title-name">
                                    {I18n.get('ORG-INFOR-LABEL-ORG-NAME')}
                                    <span className="required">*</span>
                                </div>
                                <FormInput
                                    defaultValue={
                                        initData.corporationData.name
                                            ? initData.corporationData.name
                                            : ''
                                    }
                                    required={true}
                                    errorlist={errors}
                                    name="corporationName"
                                    className="input-corp-name form-control-wrapInput form-control-hg40"
                                    variant="outlined"
                                    inputProps={{
                                        'data-cy': 'org-profile-input-corp-name',
                                        readOnly: !Utils.isAdminUser(userDetail),
                                        onChange: e => {
                                            setValue('corporationName', e.target.value.trim());
                                            clearErrors('corporationName');
                                            setIsEdited(true);
                                        },
                                        onBlur: e => {
                                            let blurValue = e.target.value.trim();
                                            if (Utils.isEmptyString(blurValue)) {
                                                setError(
                                                    'corporationName',
                                                    {
                                                        type: 'manual',
                                                        message: I18n.get('COMMSG014')
                                                    },
                                                    { shouldFocus: false }
                                                );
                                            } else {
                                                setValue('corporationName', blurValue);
                                                clearErrors('corporationName');
                                            }
                                        }
                                    }}
                                />
                            </div>

                            {/* ADMIN-LIST */}
                            <div className="org-profile-field">
                                <div className="title-name">
                                    {I18n.get('ORG-INFOR-LABEL-ADMIN-NAME')}
                                    <span className="required">*</span>
                                </div>

                                <TextField
                                    className="form-control form-control--wrap form-control--hg40"
                                    select
                                    disabled={!Utils.isAdminUser(userDetail)}
                                    variant="outlined"
                                    name="selectedAdmin"
                                    value={`${adminName}`}
                                    defaultValue={`${adminName}`}
                                    SelectProps={{
                                        value: `${adminName}`,
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                    onChange={e => {
                                        const selectedAdmin = adminList.find(
                                            admin => admin.fullName === e.target.value
                                        );
                                        setAdminName(e.target.value);
                                        setValue('selectedAdmin', selectedAdmin);
                                        setAdminMail(selectedAdmin.mail);
                                        setValue('mailAdmin', selectedAdmin.mail);
                                        setIsEdited(true);
                                    }}
                                >
                                    {adminList.map(admin => {
                                        return (
                                            <MenuItem
                                                key={`admin-${admin.id}`}
                                                value={admin.fullName}
                                            >
                                                <OverFlowTooltipWithTabsMui
                                                    className={`className-${admin.id}`}
                                                    value={admin.fullName}
                                                >
                                                    {admin.fullName}
                                                </OverFlowTooltipWithTabsMui>
                                            </MenuItem>
                                        );
                                    })}
                                </TextField>
                            </div>

                            {/* ADMIN-MAIL */}
                            <div className="org-profile-field">
                                <div className="title-name">
                                    {I18n.get('ORG-INFOR-LABEL-ADMIN-MAIL')}
                                </div>
                                <TextField
                                    name="mailAdmin"
                                    className="form-control form-control--wrap form-control--hg40 edit-org-input"
                                    variant="outlined"
                                    autoComplete="off"
                                    value={adminMail}
                                    disabled={true}
                                />
                            </div>

                            {/* PHONE */}
                            <div className="org-profile-field">
                                <div className="title-name">
                                    {I18n.get('LABEL-PHONE-NUMBER')}
                                    {!isAdminGuest && <span className="required">*</span>}
                                </div>
                                <PhoneInput
                                    country={'jp'}
                                    disabled={!Utils.isAdminUser(userDetail)}
                                    value={corporationPhone || '+81'}
                                    onChange={onChangePhoneNumber}
                                    onBlur={onBlurPhoneInput}
                                    countryCodeEditable={false}
                                    placeholder={I18n.get('COMMSG067').replace(
                                        '{{item}}',
                                        '電話番号'
                                    )}
                                    name="telNumberCorporation"
                                    inputProps={{
                                        name: 'telNumberCorporation',
                                        className: 'form-control edit-org-input',
                                        variant: 'outlined',
                                        size: 'small'
                                    }}
                                    data-cy="create-org-input-corp-phone"
                                />
                                <div style={{ marginTop: '5px' }}>
                                    <ErrorHelper
                                        isShowError={
                                            errors && errors.hasOwnProperty('telNumberCorporation')
                                        }
                                        textError={errors['telNumberCorporation']?.message}
                                        customCss={{
                                            customText: {
                                                fontWeight: 700,
                                                fontSize: '0.88rem',
                                                lineHeight: '1.4',
                                                opacity: '0.8'
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            {/* SUB-DOMAIN */}
                            <div className="org-profile-field">
                                <div className="title-name">
                                    {I18n.get('ORG-INFOR-LABEL-SUBDOMAIN')}
                                </div>
                                <TextField
                                    name="subDomainCorportion"
                                    className="form-control form-control--wrap form-control--hg40 edit-org-input"
                                    variant="outlined"
                                    autoComplete="off"
                                    disabled={true}
                                    value={subDomain}
                                />
                            </div>
                        </div>

                        {initData.corporationData.limitValue.chatAI ===
                            Constant.STATUS_SERVICE_PERMISSION.ON && (
                            <div className="org-profile-wrap-footer-ai">
                                <div
                                    className="org-profile-wrap-title"
                                    data-cy="org-profile-header-title"
                                >
                                    {I18n.get('ORG-INFOR-LABEL-AI-SETTING')}
                                </div>

                                {/* AI-chat */}
                                <div className="org-profile-field horizontal-field">
                                    <div className="title-name setting-ai-function">
                                        {I18n.get('ORG-INFOR-LABEL-USE-AI')}
                                    </div>

                                    <div className="switch-check setting-ai-function">
                                        <input
                                            name="chatAI"
                                            id="ai-chat-id"
                                            type="checkbox"
                                            disabled={!enableOnChangeVectorData}
                                            checked={usingChatAI}
                                            onChange={e => {
                                                let usingChatAIValue = !usingChatAI;
                                                setUsingChatAI(usingChatAIValue);
                                                setValue(
                                                    'usingChatAI',
                                                    usingChatAIValue
                                                        ? Constant.STATUS_SERVICE_PERMISSION.ON
                                                        : Constant.STATUS_SERVICE_PERMISSION.OFF
                                                );
                                                setIsEdited(true);
                                                setLincenseKey(prev => ({
                                                    ...prev,
                                                    error: ''
                                                }));
                                                if (!usingChatAIValue) {
                                                    setLincenseKey(prev => ({
                                                        ...prev,
                                                        value: licenseKeyDefault,
                                                        error: ''
                                                    }));
                                                    setSystemPrompt(systemPromptDefault);
                                                    setInteratorSystemPrompt(interatorSystemPromptDefault);
                                                    setChatGPTModel(chatGPTModelDefault);
                                                    setKnn(knnDefault);
                                                    setMinScore(minScoreDefault);
                                                    setUsingAIAuto(usingChatAIValue);
                                                    setInputSystemPrompt('');
                                                    setInputInteratorSystemPrompt('');
                                                }
                                            }}
                                        />
                                        <label htmlFor="ai-chat-id"></label>
                                    </div>

                                    {(corporationDetail?.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON) && (
                                        <>
                                            {corporationDetail?.limitValue?.vectorTicketDataStatus ===
                                            Constant.VECTOR_DATA_STATUS.DONE ? (
                                                <div className='color-vector-done'>AI用ベクトル準備済</div>
                                            ) : (
                                                <div className='color-vector-inprogress'>AI用ベクトル作成中</div>
                                            )}
                                        </>
                                    )}
                                </div>

                                {initData.corporationData.limitValue.chatAI === Constant.STATUS_SERVICE_PERMISSION.ON && (
                                    <>
                                        <div className={`org-profile-field`}>
                                            <div className="title-name">
                                                {I18n.get('ORG-INFOR-LABEL-LICENSE-AI')}
                                            </div>
                                            <input
                                                name="lincenseKey"
                                                type='text'
                                                className={`private-lincenseKey-input ${!Utils.isEmptyString(lincenseKey.error) && 'error'}`}
                                                value={lincenseKey.value}
                                                disabled={!usingChatAI}
                                                onChange={e => handleChangeInputLincenseKey(e)}
                                                onWheel={e => e.target.blur()}
                                                onBlur={e => {
                                                    const value = e.target.value;
                                                    if (
                                                        !lincenseKeyPermission &&
                                                        usingChatAI &&
                                                        value.length == 0
                                                    ) {
                                                        setLincenseKey(prev => ({
                                                            ...prev,
                                                            error: I18n.get('MSG_AI_LICENSE_KEY_REQUIRED')
                                                        }))
                                                    }
                                                }}
                                            />
                                        </div>
                                        
                                        {!lincenseKeyPermission && (
                                            <div className='lincenseKey-instruction'>
                                                <img className='icon-instruction-chat-ai' src="/assets/image/icon-instruction-chat-ai.svg" alt="icon" />
                                                <span className='text-instruction-chat-ai'>
                                                    {I18n.get('LABEL-AI-LICENSE-KEY-SETTING-INSTRUCTION')}
                                                </span>
                                            </div>
                                        )}
                                        {!Utils.isEmptyString(lincenseKey.error) && (
                                            <div className='lincenseKey-instruction'>
                                                <span className='text-warning-chat-ai'>
                                                    {lincenseKey.error}
                                                </span>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}

                        {usingChatAI && (
                        <div className="org-setting-ai">
                            {/* TITLE SETTING ADVANCED */}
                            <div className='org-setting-ai-chatgpt-header'>
                                <div className='title-name'>
                                    <div className='label-title'>
                                        <label className='label-text-advanced'>
                                            {I18n.get('ORG-INFOR-LABEL-SETTING-ADVANCED')}
                                        </label>
                                    </div>
                                    <div>
                                        <label className='label-text-advanced'>
                                            {I18n.get('ORG-INFOR-TEXT-SETTING-ADVANCED')}
                                        </label>  
                                    </div>
                                </div>
                            </div>
                            
                            {/* CHATGPT_MODEL */}
                            <div className="org-setting-ai-chatgpt">
                                <div className="org-setting-ai-chatgpt-header">
                                    <div className="title-name">
                                    <Tooltip title={I18n.get('LABEL-SETTING-CHATGPT-MODEL')} arrow= {false} placement = "top-start">
                                        <div>
                                            <label
                                                className="label-search-pdf"
                                                htmlFor={`checkbox-include-search-synonym-helpdesk-list`}
                                            >
                                                {I18n.get('ORG-INFOR-LABEL-CHATGPT-MODEL')}
                                            </label>
                                            <span className="required">*</span>
                                        </div>
                                    </Tooltip>
                                    </div>
                                    <div className="org-setting-ai-chatgpt-header-right" onClick={() => setIsShowMsgSettingAI(true)}>
                                        <img className='title-name' src="/assets/image/icon-reset.svg" alt="reset"/>
                                        <div className="title-name">{I18n.get('ORG-INFOR-LABEL-RESET')}</div>
                                    </div>
                                </div>
                               
                                <TextField
                                    className="form-control form-control--wrap form-control--hg40 width-70"
                                    select
                                    disabled={isDisableChatGPTInput()}
                                    variant="outlined"
                                    name="selectedChatGPTModel"
                                    value={`${chatGPTModel}`}
                                    defaultValue={`${chatGPTModel}`}
                                    SelectProps={{
                                        value: `${chatGPTModel}`,
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                    onChange={e => {
                                        setChatGPTModel(e.target.value);
                                        setIsEdited(true);
                                    }}
                                >
                                    {chatGPTModelList?.map(chatGPT => {
                                        return (
                                            <MenuItem
                                                key={`chatGPT-${chatGPT.id}`}
                                                value={chatGPT.id}
                                            >
                                                <OverFlowTooltipWithTabsMui
                                                    className={`className-${chatGPT.id}`}
                                                    value={chatGPT.id}
                                                >
                                                    {chatGPT.id}
                                                </OverFlowTooltipWithTabsMui>
                                            </MenuItem>
                                        );
                                    })}
                                </TextField>
                            </div>
                            
                            {/* KNN_VALUE */}

                            <div className="org-setting-ai-knn">
                                <div className="title-name horizontal-field">
                                    <Tooltip title={I18n.get('LABEL-SETTING-KNN')} arrow= {false} placement = "top-start">
                                        <div>
                                            <label
                                                className="label-search-pdf"
                                                htmlFor={`checkbox-include-search-synonym-helpdesk-list`}
                                            >
                                                {I18n.get('ORG-INFOR-LABEL-KNN-VALUE')}
                                            </label>
                                            <span className="required">*</span>
                                        </div>
                                    </Tooltip>
                                </div>
                                <TextField
                                    name="knnValue"
                                    className="form-control form-control--wrap form-control--hg40 edit-org-input width-70"
                                    variant="outlined"
                                    autoComplete="off"
                                    value={knn.value}
                                    onChange={e => handleChangeInputKnn(e)}
                                    onBlur={e => handleOnBlurInputKnn(e)}
                                    // onKeyDown={e => handleKeyDownInputKnn(e)}
                                    type='text'
                                    helperText={knn.error}
                                    error={!Utils.isEmptyString(knn.error)}
                                />
                            </div>

                            {/* MIN_SCORE */}

                            <div className="org-setting-ai-minscore">
                                <div className="title-name horizontal-field">
                                <Tooltip title={I18n.get('LABEL-SETTING-MIN-SCORE')} arrow= {false} placement = "top-start">
                                        <div>
                                            <label
                                                className="label-search-pdf"
                                                htmlFor={`checkbox-include-search-synonym-helpdesk-list`}
                                            >
                                                {I18n.get('ORG-INFOR-LABEL-MIN-SCORE')}
                                            </label>
                                            <span className="required">*</span>
                                        </div>
                                    </Tooltip>
                                </div>

                                <TextField
                                    name="minScore"
                                    className="form-control form-control--wrap form-control--hg40 edit-org-input width-70"
                                    variant="outlined"
                                    autoComplete="off"
                                    value={minScore.value}
                                    onChange={e => handleChangeInputMinScore(e)}
                                    onBlur={e => handleOnBlurInputMinScore(e)}
                                    // onKeyDown={e => handleKeyDownInputMinScore(e)}
                                    type='text'
                                    helperText={minScore.error}
                                    error={!Utils.isEmptyString(minScore.error)}
                                />
                                
                            </div>
                        </div>
                        )}
        
                        {initData.corporationData.limitValue.aiAuto === Constant.STATUS_SERVICE_PERMISSION.ON && (
                            <div className="org-profile-wrap-footer-ai-auto">
                                {/* AI-Auto */}
                                <div className={`org-profile-field horizontal-field gap-16 ${!usingChatAI ? 'org-profile-interator-prompt' : ''}`}>
                                    <div className="title-name">
                                        {I18n.get('ORG-INFOR-LABEL-AI-AUTO')}
                                    </div>

                                    <div className="switch-check">
                                        <input
                                            name="aiAuto"
                                            id="ai-auto"
                                            type="checkbox"
                                            disabled={!usingChatAI}
                                            checked={usingAIAuto}
                                            onChange={e => {
                                                let usingAIAutoValue = !usingAIAuto;
                                                setUsingAIAuto(usingAIAutoValue);
                                                if (!usingAIAutoValue) {
                                                    setSystemPrompt(systemPromptDefault);
                                                    setInputSystemPrompt('');
                                                    setInteratorSystemPrompt(interatorSystemPromptDefault);
                                                    setInputInteratorSystemPrompt('');
                                                }
                                                setIsEdited(true);
                                            }}
                                        />
                                        <label htmlFor="ai-auto"></label>
                                    </div>
                                </div>
                                <div className="org-profile-field org-profile-system-prompt">
                                    <div className="title-name">
                                        {ProductManagementConstant.TEXTBOX_SETTING_SYSTEM_PROMPT}
                                    </div>
                                    {renderFieldSystemPrompt(
                                        systemPrompt,
                                        setSystemPrompt,
                                        setIsChangeSystemPrompt,
                                        inputSystemPrompt,
                                        setInputSystemPrompt)}
                                </div>
                                <div className="org-profile-field org-profile-system-prompt org-profile-interator-prompt">
                                    <div className="title-name">
                                        {ProductManagementConstant.TEXTBOX_SETTING_INTERATOR_SYSTEM_PROMPT}
                                    </div>
                                    {renderFieldSystemPrompt(
                                        interatorSystemPrompt,
                                        setInteratorSystemPrompt,
                                        setIsChangeInteratorSystemPrompt,
                                        inputInteratorSystemPrompt,
                                        setInputInteratorSystemPrompt)}
                                </div>
                            </div>
                        )}
                        {initData?.corporationData?.limitValue?.ipRestriction === Constant.STATUS_SERVICE_PERMISSION.ON && (
                            <IPRestrictionSetting
                                //state
                                usingIpAddressRestrict={usingIpAddressRestrict}
                                error={ipRestrictionError}
                                ipAddressRange={ipAddressRange}
                                //state
                                setError={setIPRestrictionError}
                                setIsEdited={setIsEdited}
                                setUsingIpAddressRestrict={setUsingIpAddressRestrict}
                                setIpAddressRange={setIpAddressRange}
                                //event
                                onChangeUsingIpAddressRestrict={onChangeUsingIpAddressRestrict}
                                onChangeIpAddressRange={onChangeIpAddressRange}
                                changeIpAddressRange={changeIpAddressRange}
                            />
                        )}
                    </FormProvider>

                    {/* dialog select img  */}
                    <CropImage
                        openCrop={openCrop}
                        setOpenCrop={setOpenCrop}
                        aspect={aspect}
                        cropShape={cropShape}
                        inputImage={inputImage}
                        setInputImage={setInputImage}
                        setCroppedImage={setCroppedImage}
                        setErrorImage={setErrorImage}
                        setImagePreview={setImagePreview}
                        imageName={logoFileName}
                        setImageName={setLogoFileName}
                        oldImageName={oldLogoFileName}
                        setOldImageName={setOldLogoFileName}
                        setIsEdited={setIsEdited}
                    />

                    {/* dialog confirm close tab or cancel  */}
                    <ConfirmDialog
                        isOpen={isShowPopUpCloseTab || isShowPopUpCancel}
                        msgConfirm={I18n.get('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                        okCallBack={handleSubmit(onSubmitEditCorporation)}
                        closeCallBack={async () => {
                            if (isShowPopUpCloseTab) {
                                handleCloseTab(
                                    props.panelId,
                                    props.tabId,
                                    panelList,
                                    closePanelTab,
                                    setIsShowPopUpCloseTab
                                );
                            }
                            if (isShowPopUpCancel) {
                                setIsShowPopUpCancel(false);
                                getInitCorporationAndListUser(getInitCorpArgs)
                                    .then(response => {
                                        if (response) {
                                            clearErrors();
                                            setIPRestrictionError({})
                                            setIsEdited(false);
                                            setIsLoading(false);
                                            const corporationSetting = Utils.convertJSONDataToObject(
                                                corporationDetail?.corporationSetting
                                            );
                                            setUsingIpAddressRestrict(corporationSetting?.usingIpAddressRestrict)
                                            setIpAddressRange(corporationSetting?.ipAddressRange || "");
                                        }
                                    })
                                    .catch(error => {
                                        clearErrors();
                                        setIsEdited(false);
                                        setIsLoading(false);
                                        console.log('get initCorp error >>>', error);
                                    });
                            }
                        }}
                        cancelCallBack={() => {
                            if (isShowPopUpCloseTab) setIsShowPopUpCloseTab(false);
                            if (isShowPopUpCancel) setIsShowPopUpCancel(false);
                        }}
                        textSubmit={I18n.get('COMBTN002')}
                        textClose={I18n.get('COMBTN007')}
                        isShowClassnameButton={false}
                    />

                    {/* dialog reload */}
                    <DataChangePleaseReloadModal
                        isOpen={isOpenModalReloadPage}
                        setIsOpen={setIsOpenModalReloadPage}
                    />
                    <ConfirmDialog
                        isOpen={isShowMsgSettingAI}
                        msgConfirm={I18n.get('MSG-CONFIRM-RESET-SETTING-AI')}
                        closeCallBack={() => {
                            setIsShowMsgSettingAI(false);
                        }}
                        okCallBack={handlerResetAISetting}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                        textClose={I18n.get('CM-BUTTON-CANCEL')}
                    />
                </>
            ) : (
                <></>
            )}
        </div>
    );
}
